import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MultipleChoice = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7 1.47c.4.398.4 1.097 0 1.496l-13.369 13.37c-.399.399-1.097.399-1.497 0l-5.886-5.887a1.085 1.085 0 0 1 0-1.497c.399-.399 1.097-.399 1.496 0l5.189 5.188L42.204 1.47c.4-.4 1.098-.4 1.497 0ZM43.7 41.877c.4.4.4 1.098 0 1.497-.398.4-1.097.4-1.496 0l-5.986-5.986-5.987 5.986c-.399.4-1.097.4-1.496 0-.4-.4-.4-1.098 0-1.497l5.986-5.986-5.986-5.986c-.4-.4-.4-1.098 0-1.497.399-.4 1.097-.4 1.496 0l5.987 5.986 5.986-5.986c.4-.4 1.098-.4 1.497 0s.399 1.098 0 1.497l-5.987 5.986 5.987 5.986ZM15.265 41.877c.4.4.4 1.098 0 1.497-.399.4-1.097.4-1.496 0l-5.987-5.986-5.986 5.986c-.4.4-1.098.4-1.497 0s-.399-1.098 0-1.497l5.987-5.986-5.987-5.986c-.399-.4-.399-1.098 0-1.497.4-.4 1.098-.4 1.497 0l5.986 5.986 5.987-5.986c.399-.4 1.097-.4 1.496 0 .4.4.4 1.098 0 1.497L9.28 35.89l5.986 5.986ZM15.265 14.839c.4.399.4 1.097 0 1.496-.399.4-1.097.4-1.496 0L7.782 10.35l-5.986 5.986c-.4.4-1.098.4-1.497 0-.399-.399-.399-1.097 0-1.496l5.987-5.987L.299 2.866C0 2.566 0 1.868.4 1.47c.4-.399 1.098-.399 1.497 0l5.986 5.987 5.986-5.987c.4-.399 1.098-.399 1.497 0 .4.4.4 1.098 0 1.497L9.38 8.952l5.886 5.887Z"
  }));
});
MultipleChoice.displayName = 'MultipleChoice';
MultipleChoice.defaultProps = {
  'aria-label': 'MultipleChoice'
};
export default MultipleChoice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/MultipleChoice.js
// module id = 3222
// module chunks = 11